import {
  faCheck,
  faCheckCircle,
  faClockFour,
  faTimesCircle,
  faUser,
  faUserGroup,
  faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";
import piePending from "./assests/piePedning.svg";
import pendingReview from "./assests/pending-review-icon.jpg";
import exclamation from "./assests/excalamtion.svg";
import crossBrown from "./assests/crossBrown.svg";
import crossRed from "./assests/crossRed.svg";
import pieChartApprove from "./assests/pieChartApprove.svg";

export const data = [
  {
    name: "Bradly taylor",
    email: "bradlytayloar@gmail.com",
    phoneNo: "0078666201",
    insurer: "Grante",
    scheme: "GU",
    driver: "Main Driver",
    type: "New Bussiness",
    initialType: "Standard",
    status: "Approved",
    icon: faCheckCircle,
  },
  {
    name: "Janathan Suza",
    email: "janathan@gmail.com",
    phoneNo: "0078666201",
    insurer: "Policy Fast",
    scheme: "PF",
    type: "New Bussiness",
    initialType: "Standard",
    driver: "Main Driver",
    status: "Rejected",
    icon: faCheckCircle,
  },
  {
    name: "Bradly taylor",
    email: "bradlytayloar@gmail.com",
    phoneNo: "0078666201",
    insurer: "Grante",
    scheme: "GU",
    type: "New Bussiness",
    initialType: "Standard",
    driver: "Main Driver",
    status: "Approved",
    icon: faCheckCircle,
  },
  {
    name: "Janathan Suza",
    email: "janathan@gmail.com",
    phoneNo: "0078666201",
    insurer: "Policy Fast",
    type: "New Bussiness",
    initialType: "Standard",
    scheme: "PF",
    driver: "Main Driver",
    status: "Pending",
    icon: faCheckCircle,
  },
  {
    name: "Janathan Suza",
    email: "janathan@gmail.com",
    phoneNo: "0078666201",
    insurer: "Policy Fast",
    type: "New Bussiness",
    initialType: "Standard",
    scheme: "PF",
    driver: "Main Driver",
    status: "Failed",
    icon: faTimesCircle,
  },
];

export const chartsData = [
  {
    id: 1,
    year: 2016,
    userGain: 80000,
    userLost: 823,
  },
  {
    id: 2,
    year: 2017,
    userGain: 45677,
    userLost: 345,
  },
  {
    id: 3,
    year: 2018,
    userGain: 78888,
    userLost: 555,
  },
  {
    id: 4,
    year: 2019,
    userGain: 90000,
    userLost: 4555,
  },
  {
    id: 5,
    year: 2020,
    userGain: 4300,
    userLost: 234,
  },
];

export const optionsData = [
  {
    icon: faClockFour,
    textColor: "#c0c6cf",
    bgColor: "#c0c6cf10",
    label: "Awaiting Customer",
    count: 140,
    value: "Awaiting-Customer",
    img: piePending,
  },
  {
    icon: faClockFour,
    textColor: "#a4adb9",
    bgColor: "#a4adb910",
    label: "Pending Review",
    count: 140,
    value: "Pending-Review",
    img: pendingReview,
  },
  {
    icon: faCheck,
    textColor: "#75c096",
    bgColor: "#c8e6d6",
    label: "Approved",
    count: 140,
    value: "Approved",
    img: pieChartApprove,
  },
  {
    icon: faTimesCircle,
    textColor: "#ffcc24",
    bgColor: "#f0cc40",
    label: "Failed",
    count: 30,
    value: "Failed",
    img: exclamation,
  },
  {
    icon: faTimesCircle,
    textColor: "#e09b93",
    bgColor: "#a94240",
    label: "Rejected",
    count: 40,
    value: "Rejected",
    img: crossBrown,
  },
  {
    icon: faTimesCircle,
    textColor: "#a4474b",
    bgColor: "#a94240",
    label: "Cancelled",
    count: 40,
    value: "Cancelled",
    img: crossRed,
  },
  {
    icon: faTimesCircle,
    textColor: "#a4474b",
    bgColor: "#a94240",
    label: "Rebroked",
    count: 40,
    value: "Rebroked",
    img: crossRed,
  },
  {
    icon: faTimesCircle,
    textColor: "#a4474b",
    bgColor: "#a94240",
    label: "Mismatched",
    count: 40,
    value: "Mismatched",
    img: crossRed,
  },
];

export const selectData = [
  {
    label: "Driver License Summary",
    value: "Driver License Summary",
  },
  {
    label: "No Claim Bonus Proof",
    value: "No Claim Bonus Proof",
  },
];

export const selectProviderData = [
  {
    label: "GRANITE INSURANCE",
    value: "GRANITE INSURANCE",
  },
  {
    label: "HASTINGS DIRECT",
    value: "HASTINGS DIRECT",
  },
  {
    label: "VAN LINE DIRECT",
    value: "VAN LINE DIRECT",
  },
];

export const headerData = [
  "Providers",
  "Drivers Licence Summary",
  "Licence Scan",
  "NCB Digital",
  "NCB Scan",
  "V5C Scan",
  "Bank Statement",
  "Proof of Address",
  "Odometer Reading",
  "Mirrored NCB PProof",
  "Photos of Van",
];

export const bodyData = [
  {
    id: 1,
    column1: {
      title: "Granite Insurance",
      description: "New Business",
    },
    column2: { icon: faCircleXmark, color: "#EE5D50" },
    column3: { icon: faUserGroup, color: "#02CD56" },
    column4: { icon: faCircleXmark, color: "#EE5D50" },
    column5: { icon: faUserGroup, color: "#02CD56" },
    column6: { icon: faUserGroup, color: "#02CD56" },
    column7: { icon: faCircleXmark, color: "#EE5D50" },
    column8: { icon: faUser, color: "#02CD56" },
    column9: { icon: faUser, color: "#02CD56" },
    column10: { icon: faCircleXmark, color: "#EE5D50" },
    column11: { icon: faUserGroup, color: "#02CD56" },
  },
  {
    id: 2,
    column1: {
      title: "Hastings Direct",
      description: "New Business",
    },
    column2: { icon: faCircleXmark, color: "#EE5D50" },
    column3: { icon: faUserGroup, color: "#02CD56" },
    column4: { icon: faCircleXmark, color: "#EE5D50" },
    column5: { icon: faUserGroup, color: "#02CD56" },
    column6: { icon: faUserGroup, color: "#02CD56" },
    column7: { icon: faCircleXmark, color: "#EE5D50" },
    column8: { icon: faUser, color: "#02CD56" },
    column9: { icon: faUser, color: "#02CD56" },
    column10: { icon: faCircleXmark, color: "#EE5D50" },
    column11: { icon: faUserGroup, color: "#02CD56" },
  },
  {
    id: 3,
    column1: {
      title: "Van Line Direct",
      description: "Renewals",
    },
    column2: { icon: faCircleXmark, color: "#EE5D50" },
    column3: { icon: faUserGroup, color: "#02CD56" },
    column4: { icon: faCircleXmark, color: "#EE5D50" },
    column5: { icon: faUserGroup, color: "#02CD56" },
    column6: { icon: faUserGroup, color: "#02CD56" },
    column7: { icon: faCircleXmark, color: "#EE5D50" },
    column8: { icon: faUser, color: "#02CD56" },
    column9: { icon: faUser, color: "#02CD56" },
    column10: { icon: faCircleXmark, color: "#EE5D50" },
    column11: { icon: faUserGroup, color: "#02CD56" },
  },
  {
    id: 4,
    column1: {
      title: "Ageas",
      description: "New Business",
    },
    column2: { icon: faCircleXmark, color: "#EE5D50" },
    column3: { icon: faUserGroup, color: "#02CD56" },
    column4: { icon: faCircleXmark, color: "#EE5D50" },
    column5: { icon: faUserGroup, color: "#02CD56" },
    column6: { icon: faUserGroup, color: "#02CD56" },
    column7: { icon: faCircleXmark, color: "#EE5D50" },
    column8: { icon: faUser, color: "#02CD56" },
    column9: { icon: faUser, color: "#02CD56" },
    column10: { icon: faCircleXmark, color: "#EE5D50" },
    column11: { icon: faUserGroup, color: "#02CD56" },
  },
  {
    id: 5,
    column1: {
      title: "Broker Direct",
      description: "New Business",
    },
    column2: { icon: faCircleXmark, color: "#EE5D50" },
    column3: { icon: faUserGroup, color: "#02CD56" },
    column4: { icon: faCircleXmark, color: "#EE5D50" },
    column5: { icon: faUserGroup, color: "#02CD56" },
    column6: { icon: faUserGroup, color: "#02CD56" },
    column7: { icon: faCircleXmark, color: "#EE5D50" },
    column8: { icon: faUser, color: "#02CD56" },
    column9: { icon: faUser, color: "#02CD56" },
    column10: { icon: faCircleXmark, color: "#EE5D50" },
    column11: { icon: faUserGroup, color: "#02CD56" },
  },
];
export const columns = [
  "column1",
  "column2",
  "column3",
  "column4",
  "column5",
  "column6",
  "column7",
  "column8",
  "column9",
  "column10",
  "column11",
];

export const agentData = [
  {
    name: "Bradly taylor",
    email: "bradlytayloar@gmail.com",
    phoneNo: "0078666201",
    agentCode: "BS",
    type: "Agent",
    password: "New Bussiness",
    status: "Approved",
    icon: faCheckCircle,
  },
  {
    name: "Janathan Suza",
    email: "janathan@gmail.com",
    phoneNo: "0078666201",
    insurer: "Policy Fast",
    agentCode: "BS",
    password: "New Bussiness",
    type: "Invite sent",
    status: "Pending",
    icon: faCheckCircle,
  },
  {
    name: "Nicole Newton",
    email: "newton@gmail.com",
    phoneNo: "0078666201",
    insurer: "Policy Fast",
    agentCode: "BS",
    password: "New Bussiness",
    type: "Admin",
    status: "Pending",
    icon: faCheckCircle,
  },
  {
    name: "Janathan Suza",
    email: "janathan@gmail.com",
    phoneNo: "0078666201",
    insurer: "Policy Fast",
    agentCode: "BS",
    password: "New Bussiness",
    type: "Invite sent",
    status: "Pending",
    icon: faCheckCircle,
  },
  {
    name: "Janathan Suza",
    email: "janathan@gmail.com",
    phoneNo: "0078666201",
    insurer: "Policy Fast",
    agentCode: "BS",
    password: "New Bussiness",
    type: "Invite sent",
    status: "Pending",
    icon: faCheckCircle,
  },
];
